import { removeOrganizationalUnitError } from "@planzone/dto";
import { OrganizationalUnitsRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: OrganizationalUnitsRepository,
): Interactor {
  return (organizationalUnit) =>
    present(
      repository
        .removeOrganizationalUnit(organizationalUnit)
        .then((removal) => ({ organizationalUnit, ...removal }))
        .catch((e) =>
          Promise.reject({
            organizationalUnit,
            error: { ...removeOrganizationalUnitError, ...e },
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
